import React, { useState, useEffect } from 'react';
import QRCode from "react-qr-code";
import { Calendar } from '@awesome-cordova-plugins/calendar';
import { useNavigate, useParams } from 'react-router-dom';
import { db, storage, functions } from '../firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// eslint-disable-next-line no-unused-vars
import { doc, getDoc, updateDoc, Timestamp, addDoc, collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import {
  IoArrowBack,
  IoChatboxOutline,
  IoTimeOutline,
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoStarOutline,
  IoWarningOutline,
  // eslint-disable-next-line no-unused-vars
  IoMapOutline,
  IoWalletOutline,
  IoCalendarOutline,
  IoDocumentTextOutline,
  IoImagesOutline,
  IoQrCodeOutline,
  IoCameraOutline,
  IoWater, IoFlash, IoHammer, IoLeaf, IoBug, IoBuild, IoColorPalette, IoHome, IoKey, IoHappy, IoCar, IoEllipsisHorizontalCircle
} from 'react-icons/io5';
import moment from 'moment';
import { getProviderBusySlots, getProviderSchedule, isDayWorking, getWorkingSlots } from '../utils/availabilityService';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaymentForm from '../components/StripePaymentForm';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import { httpsCallable } from 'firebase/functions';
import './DetalleCotizacionScreen.css';

// --- Workflow Definition (Shared logic) ---
const workflowSteps = [
  { label: 'Solicitud', statuses: ['pendiente', 'pendiente_proveedor'] },
  { label: 'Cotización', statuses: ['pendiente_residente'] },
  { label: 'Confirmar', statuses: ['cambio_fecha_solicitado'] },
  { label: 'Programado', statuses: ['aceptada', 'servicio_programado'] },
  { label: 'En Camino', statuses: ['proveedor_en_camino'] },
  { label: 'En Sitio', statuses: ['proveedor_en_sitio'] },
  { label: 'Aprobación', statuses: ['esperando_aprobacion_final'] },
  { label: 'En Curso', statuses: ['servicio_en_curso'] },
  { label: 'Terminado', statuses: ['servicio_terminado', 'completada', 'completado'] }
];

// Helper: Icono por Categoría
const getServiceIcon = (categoria, tipo) => {
  const cat = (categoria || '').toLowerCase();
  if (cat.includes('plomería') || cat.includes('plomeria')) return <IoWater />;
  if (cat.includes('electricidad')) return <IoFlash />;
  if (cat.includes('carpintería') || cat.includes('carpinteria')) return <IoHammer />;
  if (cat.includes('jardinería') || cat.includes('jardineria')) return <IoLeaf />;
  if (cat.includes('fumigación') || cat.includes('fumigacion')) return <IoBug />;
  if (cat.includes('pintura')) return <IoColorPalette />;
  if (cat.includes('albañilería') || cat.includes('albañileria') || cat.includes('construccion')) return <IoBuild />;
  if (cat.includes('limpieza') || cat.includes('doméstico')) return <IoHome />;
  if (cat.includes('cerrajería')) return <IoKey />;
  if (cat.includes('mudanzas')) return <IoCar />;
  if (cat.includes('niñera')) return <IoHappy />;
  return <IoEllipsisHorizontalCircle />;
};

// Initialize Stripe (Same Key as PagarCuotaScreen)
const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripeKey) {
  console.warn("⚠️ REACT_APP_STRIPE_PUBLISHABLE_KEY no está definida en las variables de entorno.");
}
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

function DetalleCotizacionScreen() {
  const navigate = useNavigate();
  const { cotizacionId } = useParams();
  const { currentUser, userData } = useAuth();

  const [cotizacion, setCotizacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [acceso, setAcceso] = useState(null);

  // Reschedule States
  const [showReschedule, setShowReschedule] = useState(false);
  const [proposalDate, setProposalDate] = useState("");

  // Warranty States
  const [garantiasList, setGarantiasList] = useState([]);
  const [showWarrantyModal, setShowWarrantyModal] = useState(false);
  const [warrantyDescription, setWarrantyDescription] = useState('');
  const [warrantyFiles, setWarrantyFiles] = useState([]);
  const [warrantyPreviews, setWarrantyPreviews] = useState([]);
  const [warrantySaving, setWarrantySaving] = useState(false);

  // Availability Logic
  // Availability Logic
  const defaultTimeSlots = [
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
    '16:00', '16:30', '17:00', '17:30', '18:00'
  ];
  const [busySlots, setBusySlots] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [providerSchedule, setProviderSchedule] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState(defaultTimeSlots);

  // Fetch Busy Slots when proposal date changes (Day part)
  // Fetch Busy Slots when proposal date changes (Day part)
  useEffect(() => {
    const fetchBusyAndSchedule = async () => {
      if (!cotizacion?.proveedorId) return;

      // 1. Fetch Schedule Config
      const schedule = await getProviderSchedule(cotizacion.proveedorId);
      setProviderSchedule(schedule);

      if (!proposalDate) return;

      const dayStr = proposalDate.split('T')[0];
      setLoadingSlots(true);

      const [y, m, d] = dayStr.split('-').map(Number);
      const start = new Date(y, m - 1, d, 0, 0, 0, 0);
      const end = new Date(y, m - 1, d, 23, 59, 59, 999);

      const slots = await getProviderBusySlots(cotizacion.proveedorId, start, end, cotizacion.id);
      setBusySlots(slots);
      setLoadingSlots(false);
    };
    fetchBusyAndSchedule();
  }, [proposalDate, cotizacion]);

  // Update available slots when day or schedule changes
  useEffect(() => {
    if (proposalDate) {
      const dayStr = proposalDate.split('T')[0];
      if (providerSchedule) {
        if (!isDayWorking(dayStr, providerSchedule)) {
          setAvailableTimeSlots([]);
        } else {
          const slots = getWorkingSlots(dayStr, providerSchedule);
          setAvailableTimeSlots(slots);
        }
      } else {
        setAvailableTimeSlots(defaultTimeSlots);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposalDate, providerSchedule]);

  const isTimeBlocked = (timeStr) => {
    if (!proposalDate) return true;
    const dayStr = proposalDate.split('T')[0];
    const slotStart = moment(`${dayStr}T${timeStr}`);

    // 1. Past Check (give 30 min buffer)
    if (slotStart.isBefore(moment().add(30, 'minutes'))) return true;

    // Assume 2 hour duration for the new slot
    const slotEnd = moment(slotStart).add(2, 'hours');

    return busySlots.some(busy => {
      const busyStart = moment(busy.start);
      const busyEnd = moment(busy.end);
      return (slotStart < busyEnd && slotEnd > busyStart);
    });
  };

  // Stripe States
  const [mostrarStripe, setMostrarStripe] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [iniciandoPago, setIniciandoPago] = useState(false);
  const [tempCargoId, setTempCargoId] = useState(null);

  // Escuchar Cotización
  useEffect(() => {
    if (!cotizacionId || !currentUser) return;

    const unsub = onSnapshot(doc(db, "cotizaciones", cotizacionId), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        // Allow Resident OR Provider OR Admin
        if (data.residenteId === currentUser.uid || data.proveedorId === currentUser.uid /* || isAdmin */) {
          setCotizacion({ id: docSnap.id, ...data });
          setLoading(false);
        } else {
          // Check provider profile (backup check if providerId logic differs)
          // For now assume security rules handle the 'get' permission denial if not allowed
          setCotizacion({ id: docSnap.id, ...data }); // Let rules handle permission error via catch
          setLoading(false);
        }
      } else {
        setError("Cotización no encontrada.");
        setLoading(false);
      }
    }, (err) => {
      console.error(err);
      if (err.code === 'permission-denied') {
        setError("No tienes permiso para ver esta cotización.");
      } else {
        setError("Error cargando.");
      }
      setLoading(false);
    });

    return () => unsub();
  }, [cotizacionId, currentUser]);

  // Escuchar Accesos Activos
  useEffect(() => {
    if (!cotizacionId) return;
    const q = query(
      collection(db, "accesos"),
      where("cotizacionId", "==", cotizacionId),
      where("estatus", "==", "Activo")
    );
    const unsubscribe = onSnapshot(q, (snap) => {
      if (!snap.empty) {
        setAcceso({ id: snap.docs[0].id, ...snap.docs[0].data() });
      } else {
        setAcceso(null);
      }
    }, (error) => {
      // Provider might not have permission to query 'accesos' generally? 
      // We verified rules allow 'read if auth!=null'. So this should be fine.
      console.log("Error querying accesos", error);
    });
    return () => unsubscribe();
  }, [cotizacionId]);

  // Load existing warranty reports
  useEffect(() => {
    if (!cotizacionId) return;
    const q = query(
      collection(db, `cotizaciones/${cotizacionId}/garantias`),
      orderBy('fecha', 'desc')
    );
    const unsubscribe = onSnapshot(q, (snap) => {
      setGarantiasList(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (error) => {
      console.log("Error fetching warranties:", error);
    });
    return () => unsubscribe();
  }, [cotizacionId]);

  const handleWarrantyFileChange = (e) => {
    const files = Array.from(e.target.files);
    setWarrantyFiles(files);
    const newPreviews = files
      .filter(file => file.type.startsWith('image/'))
      .map(file => URL.createObjectURL(file));
    setWarrantyPreviews(newPreviews);
  };

  const handleSaveWarranty = async (e) => {
    e.preventDefault();
    if (!warrantyDescription.trim()) {
      alert("Por favor describe el problema.");
      return;
    }
    setWarrantySaving(true);
    let urls = [];
    try {
      // 1. Upload files
      for (const file of warrantyFiles) {
        const storageRef = ref(storage, `garantias/${cotizacionId}/${Date.now()}_${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const url = await getDownloadURL(snapshot.ref);
        urls.push(url);
      }

      // 2. Add doc to sub-collection
      await addDoc(collection(db, `cotizaciones/${cotizacionId}/garantias`), {
        descripcion: warrantyDescription.trim(),
        fotosUrls: urls,
        fecha: Timestamp.now(),
        estatus: 'Abierto', // Abierto, En Proceso, Resuelto
      });

      setWarrantyDescription('');
      setWarrantyFiles([]);
      setWarrantyPreviews([]);
      setShowWarrantyModal(false);
      alert("Tu solicitud de garantía ha sido enviada al proveedor y a la administración.");
    } catch (err) {
      console.error(err);
      alert("Error al registrar reporte de garantía.");
    } finally {
      setWarrantySaving(false);
    }
  };

  const handleUpdateStatus = async (newStatus, msg) => {
    if (msg && !window.confirm(msg)) return;

    setLoading(true);
    try {
      const docRef = doc(db, "cotizaciones", cotizacionId);
      await updateDoc(docRef, { estatus: newStatus });
    } catch (e) {
      console.error(e);
      alert("Error al actualizar.");
    }
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars
  const calculateTotal = (fecha) => {
    // Calculate total based on duration? (Simple version: keep fixed cost)
    return cotizacion?.costoFinal || 0;
  }

  // Resident: Proposes new date
  const handleRequestReschedule = async () => {
    if (!proposalDate) return alert("Selecciona una fecha y hora.");
    if (!window.confirm(`¿Solicitar cambio de fecha a: ${moment(proposalDate).format('DD/MM/YYYY HH:mm')}?`)) return;

    setLoading(true);
    try {
      await updateDoc(doc(db, "cotizaciones", cotizacionId), {
        estatus: 'cambio_fecha_solicitado',
        fechaPropuestaResidente: Timestamp.fromDate(new Date(proposalDate))
      });
      alert("Solicitud enviada al proveedor.");
      setShowReschedule(false);
    } catch (e) {
      console.error(e);
      alert("Error al solicitar cambio.");
    }
    setLoading(false);
  };

  // Provider: Accepts new date
  const handleAcceptReschedule = async () => {
    if (!window.confirm("¿Aceptar la nueva fecha propuesta por el cliente?")) return;
    setLoading(true);
    try {
      await updateDoc(doc(db, "cotizaciones", cotizacionId), {
        estatus: 'servicio_programado',
        fechaHoraServicioSugerido: cotizacion.fechaPropuestaResidente, // Update official date
        fechaPropuestaResidente: null // Clear temp
      });
      alert("Fecha actualizada y servicio programado.");
    } catch (e) {
      console.error(e);
      alert("Error al actualizar.");
    }
    setLoading(false);
  };

  // Calendar Handler
  const handleAddToCalendar = async () => {
    if (!cotizacion.fechaHoraServicioSugerido) return alert("No hay fecha definida.");

    try {
      const hasPermission = await Calendar.hasReadWritePermission();
      if (!hasPermission) {
        await Calendar.requestReadWritePermission();
      }

      const startDate = cotizacion.fechaHoraServicioSugerido.toDate();
      const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // Assume 1 hour default

      const title = `Servicio: ${cotizacion.tipoServicio}`;
      const location = "Mi Condominio";
      const notes = `Proveedor: ${cotizacion.nombreProveedor}\nCosto: $${cotizacion.costoFinal || 'N/A'}`;

      await Calendar.createEvent(title, location, notes, startDate, endDate);

      // Native Toast
      alert("✅ Evento agregado a tu calendario.");

    } catch (e) {
      console.error("Calendar Error:", e);
      alert("No se pudo agregar al calendario. Verifica los permisos.");
    }
  };

  // Rejection Logic
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");

  const initiateRejection = () => {
    // If Reschedule Request, force modal
    if (cotizacion.estatus === 'cambio_fecha_solicitado') {
      setShowRejectionModal(true);
    } else {
      // Standard rejection
      handleUpdateStatus('rechazada', "¿Seguro que deseas rechazar este servicio?");
    }
  };

  const confirmRejection = async () => {
    if (!rejectionReason.trim()) return alert("Por favor indica el motivo del rechazo.");

    setLoading(true);
    try {
      const who = (currentUser.uid === cotizacion.proveedorId) ? 'proveedor' : 'residente';
      await updateDoc(doc(db, "cotizaciones", cotizacionId), {
        estatus: 'rechazada',
        rechazadoPor: who,
        motivoRechazo: rejectionReason,
        fechaRechazo: Timestamp.now()
      });
      setShowRejectionModal(false);
      alert("Solicitud rechazada. El cliente será notificado.");
    } catch (e) {
      console.error(e);
      alert("Error al rechazar.");
    }
    setLoading(false);
  };

  const handleGenerarAcceso = async () => {
    if (!cotizacion) return;
    const confirmMsg = "Se generará un Acceso QR para este proveedor con validez para HOY (09:00 - 18:00). ¿Confirmar?";
    if (!window.confirm(confirmMsg)) return;

    try {
      const token = Math.floor(100000 + Math.random() * 900000).toString(); // 6 dígitos numéricos
      const now = new Date();
      const inicio = new Date(now.setHours(0, 0, 0, 0));
      const fin = new Date(now.setHours(23, 59, 59, 999));

      await addDoc(collection(db, "accesos"), {
        residenteId: currentUser.uid,
        condominioId: cotizacion.condominioId || '',
        cuentaPadreId: userData?.cuentaPadreId || null,
        cotizacionId: cotizacionId,
        token: token,
        tipo: 'Proveedor',
        tipoProveedor: 'Empresa',
        nombreComercial: cotizacion.nombreProveedor,
        tipoServicio: cotizacion.categoria || cotizacion.tipoServicio,
        contacto: 'Marketplace',
        fechaInicio: Timestamp.fromDate(inicio),
        expira: Timestamp.fromDate(fin),
        usosDiariosMaximos: 2,
        usosActuales: 0,
        horarioInicio: '09:00',
        horarioFin: '18:00',
        estatus: 'Activo',
        origen: 'Marketplace'
      });
    } catch (e) {
      console.error("Error generando acceso:", e);
      alert("Error al generar el acceso.");
    }
  };

  // --- PAYMENT LOGIC ---
  const handleIniciarPago = async () => {
    if (!cotizacion.costoFinal) return alert("Error: No hay costo final definido.");

    setIniciandoPago(true);
    try {
      // 1. Crear Cargo Temporal en Firestore (para generar el Charge ID)
      const cargoRef = await addDoc(collection(db, "cargos"), {
        tipo: 'Servicio Marketplace',
        descripcion: `Servicio de ${cotizacion.tipoServicio}`,
        monto: Number(cotizacion.costoFinal),
        residenteId: currentUser.uid,
        usuarioId: currentUser.uid, // Redundancy
        condominioId: cotizacion.condominioId,
        estatus: 'pendiente',
        fechaVencimiento: Timestamp.now(),
        cotizacionId: cotizacionId,
        proveedorId: cotizacion.proveedorId,
        origen: 'marketplace',
        creadoEn: Timestamp.now()
      });

      setTempCargoId(cargoRef.id);

      // 2. Call Payment Intent Endpoint
      const createPaymentIntentFn = httpsCallable(functions, 'createPaymentIntent');
      const { data } = await createPaymentIntentFn({
        currency: 'mxn',
        chargeIds: [cargoRef.id],
        condominioId: cotizacion.condominioId,
        proveedorId: cotizacion.proveedorId
      });

      setClientSecret(data.clientSecret);
      setMostrarStripe(true);

    } catch (error) {
      console.error("Error preparando pago:", error);
      alert("No se pudo iniciar el pago: " + error.message);
    }
    setIniciandoPago(false);
  };

  const handlePaymentSuccess = async () => {
    setLoading(true);
    try {
      // 1. Update Cargo to Paid
      if (tempCargoId) {
        await updateDoc(doc(db, "cargos", tempCargoId), {
          estatus: "pagado",
          fechaPago: Timestamp.now(),
          metodoPago: "Stripe"
        });
      }

      // 2. Update Quote Status
      await updateDoc(doc(db, "cotizaciones", cotizacionId), {
        estatus: 'servicio_en_curso',
        cargoId: tempCargoId, // Link cargo
        fechaPago: Timestamp.now()
      });

      alert("¡Pago Exitoso! El servicio ha sido aprobado.");
      setMostrarStripe(false);
      setClientSecret(null);

    } catch (e) {
      console.error("Error post-pago:", e);
      alert("Pago realizado pero hubo un error actualizando el estado. Contacta soporte.");
    }
    setLoading(false);
  };

  const options = {
    clientSecret,
    appearance: { theme: 'stripe' },
  };


  // Timeline Helper
  const getStepClass = (stepRequestStatuses) => {
    if (!cotizacion) return 'status-step';
    const currentStepIndex = workflowSteps.findIndex(step => step.statuses.includes(cotizacion.estatus));
    const renderStepIndex = workflowSteps.findIndex(step => JSON.stringify(step.statuses) === JSON.stringify(stepRequestStatuses));

    // Cancelled Logic
    const isCancelled = cotizacion.estatus.includes('cancelad') || cotizacion.estatus.includes('rechazad');
    if (isCancelled) {
      return 'status-step cancelled-view';
    }

    if (currentStepIndex === -1) return 'status-step';
    if (currentStepIndex > renderStepIndex) return 'status-step completed';
    if (currentStepIndex === renderStepIndex) return 'status-step active';
    return 'status-step';
  };

  // Icon Helper for Timeline
  const getStepIcon = (index, statusClass) => {
    if (statusClass.includes('completed')) return <IoCheckmarkCircleOutline />;
    if (statusClass.includes('active')) return <IoTimeOutline />;
    return index + 1;
  };

  if (loading && !cotizacion) return <div className="detalle-cotizacion-container"><p style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Cargando detalles...</p></div>;
  if (error) return (
    <div className="detalle-cotizacion-container">
      <div className="detalle-header-row">
        <button onClick={() => navigate('/marketplace/mis-cotizaciones')} className="detalle-back-btn"><IoArrowBack size={24} /></button>
        <h1>Error</h1>
      </div>
      <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
    </div>
  );

  // --- SPECIAL VIEW: PROVIDER RESCHEDULE REQUEST ---
  // The user requested a "small screen" focused only on the decision
  if (cotizacion && cotizacion.estatus === 'cambio_fecha_solicitado' && currentUser && cotizacion.proveedorId === currentUser.uid) {
    return (
      <div className="detalle-cotizacion-container" style={{ justifyContent: 'center', alignItems: 'center', minHeight: '80vh', background: '#f3f4f6' }}>
        <div style={{ background: 'white', padding: 30, borderRadius: 15, boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '400px', width: '90%', textAlign: 'center' }}>
          <div style={{ background: '#fffbeb', width: 60, height: 60, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <IoCalendarOutline size={30} color="#d97706" />
          </div>

          <h2 style={{ color: '#111827', margin: '0 0 10px' }}>Nueva Fecha Propuesta</h2>
          <p style={{ color: '#6b7280', marginBottom: 25, fontSize: '0.95rem' }}>
            El residente <strong>{cotizacion.nombreResidente}</strong> ha solicitado cambiar la fecha del servicio.
          </p>

          <div style={{ background: '#eff6ff', padding: 20, borderRadius: 12, marginBottom: 25, border: '1px solid #bfdbfe' }}>
            <span style={{ display: 'block', fontSize: '0.8rem', color: '#1e40af', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Nueva Fecha</span>
            <strong style={{ fontSize: '1.4rem', color: '#1e3a8a', display: 'block', marginTop: 5 }}>
              {cotizacion.fechaPropuestaResidente ? moment(cotizacion.fechaPropuestaResidente.toDate()).format('ddd D MMM') : 'N/A'}
            </strong>
            <strong style={{ fontSize: '1.4rem', color: '#1e3a8a' }}>
              {cotizacion.fechaPropuestaResidente ? moment(cotizacion.fechaPropuestaResidente.toDate()).format('h:mm a') : ''}
            </strong>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button
              onClick={handleAcceptReschedule}
              className="btn-action"
              style={{ background: '#10b981', color: 'white', justifyContent: 'center', padding: '12px' }}
            >
              Aceptar Nueva Fecha
            </button>
            <button
              onClick={initiateRejection}
              className="btn-action"
              style={{ background: 'white', color: '#ef4444', border: '1px solid #ef4444', justifyContent: 'center', padding: '12px' }}
            >
              Rechazar y Cancelar
            </button>
          </div>

          {/* Rejection Modal Logic for this view */}
          {showRejectionModal && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ background: 'white', padding: 25, borderRadius: 12, width: '90%', maxWidth: '350px', textAlign: 'left' }}>
                <h3 style={{ marginTop: 0, color: '#dc2626' }}>Rechazar Solicitud</h3>
                <p style={{ fontSize: '0.9rem', color: '#4b5563' }}>Indica el motivo del rechazo:</p>
                <textarea
                  rows={3}
                  style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #d1d5db', margin: '10px 0' }}
                  placeholder="Ej: No tengo disponibilidad..."
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                />
                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={() => setShowRejectionModal(false)} style={{ flex: 1, padding: 10, borderRadius: 6, border: '1px solid #d1d5db', background: 'white' }}>Cancelar</button>
                  <button onClick={confirmRejection} style={{ flex: 1, padding: 10, borderRadius: 6, background: '#dc2626', color: 'white', border: 'none' }}>Rechazar</button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    );
  }

  const gradient = 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)';

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/marketplace" />
      
      <main className="ks-main">
        <KondoBrandHeader showBack={false} />

        <div className="ks-scroll-area">
          <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
            
            {/* Premium Fixed Header Banner - Blue-to-Indigo Gradient */}
            <div style={{
              background: gradient,
              position: 'relative',
              overflow: 'hidden',
              padding: '30px 25px',
              borderRadius: '24px',
              marginBottom: '30px',
              boxShadow: '0 12px 30px rgba(37, 99, 235, 0.15)',
              color: 'white'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', zIndex: 2, position: 'relative' }}>
                <button
                  type="button"
                  onClick={() => navigate('/marketplace/mis-cotizaciones')}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '50%',
                    width: '44px',
                    height: '44px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    color: 'white',
                    flexShrink: 0
                  }}
                  className="encuestas-glass-btn"
                >
                  <IoArrowBack size={22} />
                </button>
                <div>
                  <h1 style={{ color: 'white', margin: '0 0 6px', fontSize: '1.7rem', fontWeight: '800', fontFamily: "'Manrope', sans-serif" }}>
                    Detalle de Servicio
                  </h1>
                  <p style={{ color: 'rgba(255, 255, 255, 0.9)', margin: 0, fontSize: '0.95rem', fontWeight: '500' }}>
                    Consulta el estado de tu cotización y detalles del proveedor
                  </p>
                </div>
              </div>
              <div style={{ position: 'absolute', right: '-20px', bottom: '-40px', zIndex: 0, pointerEvents: 'none', transform: 'rotate(-10deg)', opacity: 0.12 }}>
                <IoDocumentTextOutline size={180} color="white" />
              </div>
            </div>

            {/* Timeline */}
            <div className="status-timeline">
              {workflowSteps.map((step, index) => {
                const stepClass = getStepClass(step.statuses);
                return (
            <div key={index} className={stepClass}>
              <div className="step-circle">
                {getStepIcon(index, stepClass)}
              </div>
              <span className="step-label">{step.label}</span>
            </div>
          );
        })}
      </div>

      {/* Access Token Alert */}
      {acceso && (
        <div className="access-token-box" style={{ flexDirection: 'column', alignItems: 'center', padding: 20 }}>
          <div className="token-info" style={{ width: '100%', marginBottom: 15 }}>
            <div className="token-icon"><IoQrCodeOutline /></div>
            <div>
              <h4 style={{ margin: 0, color: '#065f46' }}>Acceso Autorizado</h4>
              <p style={{ margin: 0, color: '#047857', fontSize: '0.9rem' }}>Muestra este código en la entrada.</p>
            </div>
          </div>

          <div style={{ background: 'white', padding: 15, borderRadius: 10 }}>
            <QRCode
              value={acceso.token}
              size={180}
              level="H"
            />
          </div>
          <p style={{ marginTop: 10, fontWeight: 'bold', color: '#333', fontSize: '1.2rem', letterSpacing: 2 }}>{acceso.token}</p>
          <p style={{ fontSize: '0.8rem', color: '#666' }}>Válido hoy de {acceso.horarioInicio} a {acceso.horarioFin}</p>
        </div>
      )}

      {/* Main Card */}
      <div className="detalle-card">
        {/* Card Header */}
        <div className="detalle-card-header">
          <div className="provider-profile-summary">
            {cotizacion.logoUrl ? (
              <img src={cotizacion.logoUrl} alt="Logo" className="provider-avatar-large" />
            ) : (
              <div className="provider-avatar-large">
                {(cotizacion.nombreProveedor || 'P').substring(0, 1).toUpperCase()}
              </div>
            )}
            <div>
              <div className="provider-name-large">{cotizacion.nombreProveedor}</div>
              <div className="provider-category-subtitle">
                {getServiceIcon(cotizacion.categoria, cotizacion.tipoServicio)}
                {cotizacion.categoria || cotizacion.tipoServicio}
              </div>
            </div>
          </div>
          <div className={`status-pill-large ${cotizacion.estatus.includes('pendiente') ? 'pendiente' : cotizacion.estatus.includes('aceptada') ? 'aceptada' : 'en-proceso'}`}>
            {cotizacion.estatus.replace(/_/g, " ")}
          </div>
        </div>

        {/* Rejection Info Box */}
        {(cotizacion.estatus.includes('rechazad') || cotizacion.estatus.includes('cancelad')) && (
          <div className="rejection-box" style={{ background: '#fee2e2', padding: 15, margin: '0 20px 20px', borderRadius: 8, border: '1px solid #ef4444' }}>
            <h3 style={{ color: '#dc2626', margin: '0 0 5px', display: 'flex', alignItems: 'center', gap: 8 }}>
              <IoCloseCircleOutline /> Solicitud Rechazada
            </h3>
            <p style={{ color: '#7f1d1d', margin: 0 }}>
              {cotizacion.motivoRechazo ?
                `Motivo: ${cotizacion.motivoRechazo}` :
                (cotizacion.rechazadoPor === 'proveedor' ? "El proveedor ha rechazado la solicitud." : "El residente ha cancelado la solicitud.")
              }
            </p>
          </div>
        )}

        {/* Request Section */}
        <div className="detalle-section">
          <div className="section-title"><IoDocumentTextOutline /> Tu Solicitud</div>
          <div className="request-description">
            {cotizacion.descripcion}
          </div>
          {cotizacion.adjuntosUrls && cotizacion.adjuntosUrls.length > 0 && (
            <>
              <div className="section-title" style={{ marginTop: '20px' }}><IoImagesOutline /> Adjuntos</div>
              <div className="attachments-grid">
                {cotizacion.adjuntosUrls.map((url, i) => (
                  <img key={i} src={url} alt="Adjunto" className="attachment-thumbnail" onClick={() => window.open(url, '_blank')} />
                ))}
              </div>
            </>
          )}
        </div>

        {/* Provider Response Section */}
        {(cotizacion.costoMin != null || cotizacion.comentariosProveedor) && (
          <div className="detalle-section" style={{ background: '#f8fafc' }}>
            <div className="section-title" style={{ color: '#2563eb' }}><IoChatboxOutline /> Propuesta del Proveedor</div>
            <div className="response-highlight-box">
              <div className="response-grid">
                {cotizacion.costoMin != null && (
                  <div className="response-item">
                    <span className="response-label">Estimado</span>
                    <span className="response-value price-tag">
                      ${cotizacion.costoMin} - ${cotizacion.costoMax}
                    </span>
                  </div>
                )}
                {cotizacion.tiempoServicio && (
                  <div className="response-item">
                    <span className="response-label">Duración</span>
                    <span className="response-value">{cotizacion.tiempoServicio}</span>
                  </div>
                )}
                {cotizacion.fechaHoraServicioSugerido && (
                  <div className="response-item">
                    <span className="response-label">Fecha Propuesta</span>
                    <span className="response-value" style={{ color: '#b45309' }}>
                      {moment(cotizacion.fechaHoraServicioSugerido.toDate()).format('ddd D MMM, h:mm a')}
                    </span>
                  </div>
                )}
              </div>

              {cotizacion.comentariosProveedor && (
                <div className="provider-comment-box">
                  <IoChatboxOutline className="provider-comment-icon" size={20} />
                  <div className="provider-comment-text">
                    <strong>Nota:</strong> {cotizacion.comentariosProveedor}
                  </div>
                </div>
              )}

              {/* Final Budget Section */}
              {cotizacion.estatus === 'esperando_aprobacion_final' && (
                <div style={{ marginTop: '20px', borderTop: '1px dashed #bfdbfe', paddingTop: '15px' }}>
                  <h3 style={{ color: '#1e40af', margin: '0 0 10px' }}>Presupuesto Final</h3>
                  <div className="response-item">
                    <span className="response-label">Total a Pagar</span>
                    <span className="response-value price-tag">${cotizacion.costoFinal} MXN</span>
                  </div>
                  <p style={{ marginTop: '5px', color: '#4b5563', fontSize: '0.9rem' }}>{cotizacion.descripcionFinal}</p>

                  {/* Evidencia Inicial */}
                  {cotizacion.evidenciaAntesUrls && (
                    <div style={{ marginTop: '10px' }}>
                      <small style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Evidencia Inicial:</small>
                      <div className="attachments-grid">
                        {cotizacion.evidenciaAntesUrls.map((url, i) => <img key={i} src={url} className="attachment-thumbnail" alt="evidencia-antes" onClick={() => window.open(url, '_blank')} />)}
                      </div>
                    </div>
                  )}

                  {/* Evidencia Final (RESULTADO) */}
                  {cotizacion.evidenciaFinalUrls && (
                    <div style={{ marginTop: '15px' }}>
                      <small style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#10b981' }}>Resultado Final:</small>
                      <div className="attachments-grid">
                        {cotizacion.evidenciaFinalUrls.map((url, i) => <img key={i} src={url} className="attachment-thumbnail" alt="evidencia-final" onClick={() => window.open(url, '_blank')} />)}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Action Footer */}
        <div className="action-area">
          {/* PENDIENTE RESIDENTE: Aceptar/Rechazar Cotización */}
          {cotizacion.estatus === 'pendiente_residente' && (
            <>
              <button className="btn-action btn-danger" onClick={() => handleUpdateStatus('rechazada', "¿Seguro que deseas rechazar este presupuesto?")}>
                <IoCloseCircleOutline size={18} /> Rechazar
              </button>
              <button className="btn-action btn-success" onClick={() => setShowReschedule(true)}>
                <IoCheckmarkCircleOutline size={18} /> Responder
              </button>
            </>
          )}

          {/* CAMBIO DE FECHA SOLICITADO (Provider View) */}
          {cotizacion.estatus === 'cambio_fecha_solicitado' && cotizacion.proveedorId === currentUser.uid && (
            <div className="provider-action-box" style={{ width: '100%', textAlign: 'center', background: '#fffbeb', padding: 15, borderRadius: 10, border: '1px solid #fcd34d' }}>
              <p style={{ color: '#b45309', fontWeight: 'bold' }}>⚠ El cliente solicita cambio de fecha</p>
              <p>Nueva Propuesta: {cotizacion.fechaPropuestaResidente ? moment(cotizacion.fechaPropuestaResidente.toDate()).format('ddd D MMM, HH:mm') : 'N/A'}</p>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 10 }}>
                <button className="btn-action btn-danger" onClick={initiateRejection}>Rechazar</button>
                <button className="btn-action btn-success" onClick={handleAcceptReschedule}>Aceptar Nueva Fecha</button>
              </div>
            </div>
          )}

          {/* CAMBIO DE FECHA (Resident View - Waiting) */}
          {cotizacion.estatus === 'cambio_fecha_solicitado' && cotizacion.residenteId === currentUser.uid && (
            <div style={{ padding: 15, background: '#eff6ff', borderRadius: 10, color: '#1e40af', textAlign: 'center' }}>
              <IoTimeOutline /> Esperando confirmación del proveedor para el cambio de fecha.
            </div>
          )}

          {/* CANCELAR Si está pendiente proveedor */}
          {cotizacion.estatus === 'pendiente_proveedor' && (
            <button className="btn-action btn-danger" onClick={() => handleUpdateStatus('cancelada', "Cancelar solicitud?")}>
              <IoCloseCircleOutline size={18} /> Cancelar Solicitud
            </button>
          )}

          {/* GENERAR ACCESO (Si viene en camino) */}
          {(cotizacion.estatus === 'proveedor_en_camino' || cotizacion.estatus === 'servicio_programado') && !acceso && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
              <button className="btn-action btn-primary" onClick={handleGenerarAcceso}>
                <IoQrCodeOutline size={18} /> Generar Acceso QR
              </button>

              {/* CALENDAR BUTTON */}
              <button className="btn-action btn-secondary" onClick={handleAddToCalendar} style={{ background: '#f3f4f6', color: '#1f2937', border: '1px solid #d1d5db' }}>
                <IoCalendarOutline size={18} /> Agregar al Calendario
              </button>
            </div>
          )}

          {/* APROBAR FINAL (PAGO) */}
          {cotizacion.estatus === 'esperando_aprobacion_final' && (
            <>
              <button className="btn-action btn-danger" onClick={() => handleUpdateStatus('cancelado_con_cobro', "Rechazar final?")}>
                <IoCloseCircleOutline /> Rechazar
              </button>
              <button className="btn-action btn-success" onClick={handleIniciarPago} disabled={iniciandoPago}>
                {iniciandoPago ? 'Procesando...' : <><IoWalletOutline /> Aprobar y Pagar</>}
              </button>
            </>
          )}

          {/* CALIFICAR */}
          {cotizacion.estatus === 'servicio_terminado' && (
            <button className="btn-action btn-primary" onClick={() => navigate(`/marketplace/calificar/${cotizacionId}`)}>
              <IoStarOutline size={18} /> Calificar Servicio
            </button>
          )}

          {/* COMPLETED STATUS ACTIONS (Ver/Editar Reseña & Solicitar Garantía) */}
          {(cotizacion.estatus === 'completada' || cotizacion.estatus === 'completado') && (
            <div style={{ display: 'flex', gap: '10px', width: '100%', flexWrap: 'wrap' }}>
              <button className="btn-action btn-secondary" onClick={() => navigate(`/marketplace/calificar/${cotizacionId}`)} style={{ flex: '1 1 140px' }}>
                <IoStarOutline size={18} /> Ver / Editar Reseña
              </button>
              <button className="btn-action btn-primary" onClick={() => setShowWarrantyModal(true)} style={{ flex: '1 1 140px', background: '#ef4444', border: '1px solid #ef4444', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)' }}>
                <IoWarningOutline size={18} /> Solicitar Garantía
              </button>
            </div>
          )}
        </div>

        {/* Existing Warranty Reports List */}
        {garantiasList.length > 0 && (
          <div className="detalle-section" style={{ borderTop: '1px solid #e5e7eb', marginTop: '20px', paddingTop: '20px' }}>
            <div className="section-title" style={{ color: '#dc2626', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '800', fontFamily: "'Manrope', sans-serif" }}><IoWarningOutline /> Reportes de Garantía</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '15px' }}>
              {garantiasList.map(rep => (
                <div key={rep.id} style={{ background: '#fff5f5', border: '1px solid #fecdd3', padding: '16px', borderRadius: '16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                    <span style={{ fontSize: '0.8rem', color: '#be123c', fontWeight: 'bold' }}>
                      Reportado el: {moment(rep.fecha.toDate()).format('DD/MMM/YYYY HH:mm')}
                    </span>
                    <span style={{
                      background: rep.estatus === 'Resuelto' ? '#d1fae5' : '#fee2e2',
                      color: rep.estatus === 'Resuelto' ? '#065f46' : '#9f1239',
                      padding: '3px 10px',
                      borderRadius: '9999px',
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      border: '1px solid ' + (rep.estatus === 'Resuelto' ? '#a7f3d0' : '#fca5a5')
                    }}>
                      {rep.estatus}
                    </span>
                  </div>
                  <p style={{ margin: '0 0 12px 0', fontSize: '0.9rem', color: '#7f1d1d', lineHeight: '1.4' }}>
                    {rep.descripcion}
                  </p>
                  {rep.fotosUrls && rep.fotosUrls.length > 0 && (
                    <div className="attachments-grid">
                      {rep.fotosUrls.map((url, i) => (
                        <img key={i} src={url} alt="Evidencia Garantía" className="attachment-thumbnail" onClick={() => window.open(url, '_blank')} />
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Warranty Request Modal */}
      {showWarrantyModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(6px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: '30px', borderRadius: '28px', width: '90%', maxWidth: '450px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', fontFamily: "'Inter', sans-serif" }}>
            <h3 style={{ marginTop: 0, color: '#0f172a', fontWeight: '800', fontSize: '1.3rem', fontFamily: "'Manrope', sans-serif" }}>Solicitar Garantía / Reportar Falla</h3>
            <p style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '20px', lineHeight: '1.5' }}>
              Describe a detalle el problema surgido con el servicio realizado. El proveedor y la administración serán notificados.
            </p>
            
            <form onSubmit={handleSaveWarranty} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', color: '#475569', fontWeight: '600', marginBottom: '8px' }}>Descripción de la Falla</label>
                <textarea
                  rows={4}
                  required
                  placeholder="Ej: La tubería reparada volvió a gotear hoy por la mañana..."
                  value={warrantyDescription}
                  onChange={(e) => setWarrantyDescription(e.target.value)}
                  style={{ width: '100%', padding: '12px 16px', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.95rem', color: '#1e293b', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }}
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', color: '#475569', fontWeight: '600', marginBottom: '8px' }}>Evidencia (Fotos)</label>
                <div style={{ border: '2px dashed #cbd5e1', borderRadius: '12px', padding: '20px', textAlign: 'center', background: '#fafafa', cursor: 'pointer' }}>
                  <input type="file" multiple accept="image/*" onChange={handleWarrantyFileChange} style={{ display: 'none' }} id="warranty-file" />
                  <label htmlFor="warranty-file" style={{ cursor: 'pointer', color: '#3b82f6', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                    <IoCameraOutline size={28} />
                    <span style={{ fontSize: '0.9rem', fontWeight: '600' }}>Subir fotos del problema</span>
                  </label>
                </div>
                {warrantyPreviews.length > 0 && (
                  <div className="gallery-preview" style={{ display: 'flex', gap: '8px', overflowX: 'auto', marginTop: '12px' }}>
                    {warrantyPreviews.map((src, i) => <img key={i} src={src} alt="preview" style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #e2e8f0' }} />)}
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
                <button
                  type="button"
                  onClick={() => {
                    setShowWarrantyModal(false);
                    setWarrantyDescription('');
                    setWarrantyFiles([]);
                    setWarrantyPreviews([]);
                  }}
                  style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '12px', fontWeight: '700', color: '#64748b', cursor: 'pointer' }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={warrantySaving}
                  style={{ flex: 1, padding: '12px', background: '#ef4444', border: 'none', borderRadius: '12px', fontWeight: '700', color: 'white', cursor: 'pointer', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)' }}
                >
                  {warrantySaving ? 'Enviando...' : 'Enviar Reporte'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Reschedule Modal */}
      {showReschedule && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: 25, borderRadius: 12, width: '90%', maxWidth: '400px' }}>
            <h3 style={{ marginTop: 0 }}>Confirmar Servicio</h3>
            <p>El proveedor propone:</p>
            <div style={{ background: '#f3f4f6', padding: 10, borderRadius: 8, textAlign: 'center', fontWeight: 'bold', fontSize: '1.1rem', marginBottom: 20 }}>
              {cotizacion.fechaHoraServicioSugerido ? moment(cotizacion.fechaHoraServicioSugerido.toDate()).format('ddd D MMM, h:mm a') : 'Sin Fecha'}
            </div>

            <p>¿Estás de acuerdo con esta fecha?</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <button
                className="btn-action btn-success"
                style={{ width: '100%', justifyContent: 'center' }}
                onClick={() => { setShowReschedule(false); handleUpdateStatus('servicio_programado'); }}
              >
                Sí, Confirmar Fecha
              </button>

              <div style={{ borderTop: '1px solid #e5e7eb', margin: '20px 0', paddingTop: 15 }}>
                <p style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: 10, color: '#374151' }}>Proponer nueva fecha:</p>

                {/* DATE SELECTOR */}
                <div style={{ marginBottom: 15 }}>
                  <label style={{ display: 'block', fontSize: '0.85rem', color: '#6b7280', marginBottom: 5 }}>Día</label>
                  <input
                    type="date"
                    min={new Date().toISOString().split('T')[0]}
                    value={proposalDate ? proposalDate.split('T')[0] : ''}
                    onChange={(e) => {
                      const date = e.target.value;
                      // Default time to 09:00 if not set, or keep existing time
                      const time = proposalDate ? proposalDate.split('T')[1] : '09:00';
                      setProposalDate(`${date}T${time}`);
                    }}
                    style={{ width: '100%', padding: 12, borderRadius: 8, border: '1px solid #d1d5db', fontSize: '1rem' }}
                  />
                </div>

                {/* TIME SLOTS GRID */}
                <div>
                  <label style={{ display: 'block', fontSize: '0.85rem', color: '#6b7280', marginBottom: 8 }}>Horario (Hora Exacta)</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, maxHeight: '200px', overflowY: 'auto', border: '1px solid #e5e7eb', padding: 8, borderRadius: 8 }}>
                    {availableTimeSlots.length === 0 ? (
                      <div style={{ gridSize: 'span 4', colSpan: 4, textAlign: 'center', padding: 10, color: '#ef4444', fontSize: '0.85rem' }}>
                        El proveedor no labora este día.
                      </div>
                    ) : availableTimeSlots.map(time => {
                      const blocked = isTimeBlocked(time);
                      return (
                        <button
                          key={time}
                          type="button"
                          disabled={blocked}
                          onClick={() => {
                            if (blocked) return;
                            if (!proposalDate) {
                              alert("Primero selecciona un día.");
                              return;
                            }
                            const date = proposalDate.split('T')[0];
                            setProposalDate(`${date}T${time}`);
                          }}
                          style={{
                            padding: '8px 4px',
                            background: (proposalDate && proposalDate.endsWith(time)) ? '#10b981' : (blocked ? '#f3f4f6' : 'white'),
                            color: (proposalDate && proposalDate.endsWith(time)) ? 'white' : (blocked ? '#d1d5db' : '#374151'),
                            border: (proposalDate && proposalDate.endsWith(time)) ? 'none' : '1px solid #d1d5db',
                            borderRadius: 6,
                            fontSize: '0.85rem',
                            cursor: blocked ? 'not-allowed' : 'pointer'
                          }}
                        >
                          {moment(time, 'HH:mm').format('h:mm A')}
                        </button>
                      )
                    })}
                  </div>
                </div>

                <div style={{ marginTop: 20 }}>
                  <p style={{ fontSize: '0.9rem' }}>Seleccionado: <strong>{proposalDate ? moment(proposalDate).format('DD/MM/YYYY h:mm A') : '...'}</strong></p>
                  <button
                    className="btn-action btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: 10 }}
                    onClick={handleRequestReschedule}
                    disabled={!proposalDate}
                  >
                    Enviar Propuesta
                  </button>
                </div>
              </div>
            </div>

            <button onClick={() => setShowReschedule(false)} style={{ marginTop: 15, background: 'none', border: 'none', color: '#6b7280', width: '100%', textDecoration: 'underline' }}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Stripe Modal */}
      {mostrarStripe && clientSecret && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: 25, borderRadius: 12, width: '90%', maxWidth: '400px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h2 style={{ margin: 0, fontSize: '1.2rem' }}>Pagar Servicio</h2>
              <button onClick={() => setMostrarStripe(false)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
            </div>

            <div style={{ marginBottom: 20, textAlign: 'center' }}>
              <p style={{ color: '#6b7280', margin: 0 }}>Total a Pagar</p>
              <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>${cotizacion.costoFinal}</div>
            </div>

            <Elements options={options} stripe={stripePromise}>
              <StripePaymentForm onSuccess={handlePaymentSuccess} />
            </Elements>
          </div>
        </div>
      )}

      {/* Rejection Modal */}
      {showRejectionModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: 25, borderRadius: 12, width: '90%', maxWidth: '400px' }}>
            <h3 style={{ marginTop: 0, color: '#dc2626' }}>Rechazar Solicitud</h3>
            <p style={{ fontSize: '0.9rem', color: '#4b5563' }}>
              Para ayudar al cliente a reagendar, explica por qué no puedes aceptar esta fecha y sugiere otra disponibilidad (ej. "Tengo libre el Jueves a las 4pm").
            </p>

            <textarea
              rows={4}
              style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #d1d5db', margin: '10px 0' }}
              placeholder="Ej: Ya tengo un compromiso a esa hora. Tengo libre mañana después de las 4pm..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            />

            <div style={{ display: 'flex', gap: 10, marginTop: 15 }}>
              <button
                onClick={() => setShowRejectionModal(false)}
                style={{ flex: 1, padding: 10, background: '#f3f4f6', border: 'none', borderRadius: 6, fontWeight: 'bold', color: '#4b5563', cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={confirmRejection}
                style={{ flex: 1, padding: 10, background: '#dc2626', border: 'none', borderRadius: 6, fontWeight: 'bold', color: 'white', cursor: 'pointer' }}
              >
                Confirmar Rechazo
              </button>
            </div>
          </div>
        </div>
      )}
          </div>
        </div>
        <KondoBottomNav activeRoute="/marketplace" />
      </main>
    </div>
  );
}

export default DetalleCotizacionScreen;